export var AvailablePaymentCurrency;
(function (AvailablePaymentCurrency) {
    AvailablePaymentCurrency["Cad"] = "cad";
    AvailablePaymentCurrency["Usd"] = "usd";
    AvailablePaymentCurrency["Gbp"] = "gbp";
    AvailablePaymentCurrency["Aud"] = "aud";
    AvailablePaymentCurrency["Nzd"] = "nzd";
    AvailablePaymentCurrency["Eur"] = "eur";
})(AvailablePaymentCurrency || (AvailablePaymentCurrency = {}));
export var CurrencySymbol;
(function (CurrencySymbol) {
    CurrencySymbol["Dollar"] = "$";
    CurrencySymbol["Pound"] = "\u00A3";
    CurrencySymbol["Euro"] = "\u20AC";
})(CurrencySymbol || (CurrencySymbol = {}));
// Currency to Symbol mapping
export const CURRENCY_SYMBOL_MAPPINGS = {
    [AvailablePaymentCurrency.Cad]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Usd]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Aud]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Nzd]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Gbp]: CurrencySymbol.Pound,
    [AvailablePaymentCurrency.Eur]: CurrencySymbol.Euro,
};
export const DEFAULT_CURRENCY_SYMBOL = CurrencySymbol.Dollar;
